export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SET_FAVOURITE_TAB = "SET_FAVOURITE_TAB";
export const SET_TRADATHON_LISTINGS_TAB = "SET_TRADATHON_LISTINGS_TAB";
export const SET_TIME_IN_CHART = "SET_TIME_IN_CHART";
export const SET_ACTIVE_PORTFOLIO_PAGE = "SET_ACTIVE_PORTFOLIO_PAGE";
export const SET_ORDER_TYPE = "SET_ORDER_TYPE";
export const GET_EXCHANGE_RATE = "GET_EXCHANGE_RATE";
export const SET_EXCHANGE_RATE = "SET_EXCHANGE_RATE";
export const SET_TRADATHON_RESULT_LISTING_TAB =
  "SET_TRADATHON_RESULT_LISTING_TAB";
export const SET_TRANSACTION_PAGE = "SET_TRANSACTION_PAGE";
export const CLEAR_TRANSACTIONS = "CLEAR_TRANSACTIONS";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_CURRENT_PASSWORD = "CHANGE_CURRENT_PASSWORD";
//
export const SET_RANDOM_DATA = "SET_RANDOM_DATA";
export const SET_LIVE_PRICE = "SET_LIVE_PRICE";
export const GET_ALL_CRYPTO_COINS = "GET_ALL_CRYPTO_COINS";
export const GET_GLOBAL_TICKER = "GET_GLOBAL_TICKER";
export const GET_GLOBAL_TICKER_ERROR = "GET_GLOBAL_TICKER_ERROR";
export const SORT_GLOBAL_TICKER_BY_PRICE = "SORT_GLOBAL_TICKER_BY_PRICE";
export const SORT_GLOBAL_TICKER_BY_24H = "SORT_GLOBAL_TICKER_BY_24H";
export const SORT_GLOBAL_TICKER_BY_7D = "SORT_GLOBAL_TICKER_BY_7D";
export const SORT_GLOBAL_TICKER_BY_RANK = "SORT_GLOBAL_TICKER_BY_RANK";
export const SORT_GLOBAL_TICKER_BY_NAME = "SORT_GLOBAL_TICKER_BY_NAME";
export const SORT_NORMALLY = "SORT_NORMALLY";
export const SORT_GLOBAL_TICKER_BY_MARKET_CAP =
  "SORT_GLOBAL_TICKER_BY_MARKET_CAP";
export const SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H =
  "SORT_GLOBAL_TICKER_BY_VOLUME_IN_24H";
export const GET_SINGLE_CRYPTO_DETAILS = "GET_SINGLE_CRYPTO_DETAILS";
export const GET_SINGLE_CRYPTO_DETAILS_ERROR =
  "GET_SINGLE_CRYPTO_DETAILS_ERROR";
export const CLEAR_SINGLE_CRYPTO_DETAILS = "CLEAR_SINGLE_CRYPTO_DETAILS";
export const SET_PAGE = "SET_PAGE";
export const SET_COLUMN_NAME = "SET_COLUMN_NAME";
export const GET_COMPARE_CRYPTO_COIN_DATA1 = "GET_COMPARE_CRYPTO_COIN_DATA1";
export const GET_COMPARE_CRYPTO_COIN_DATA2 = "GET_COMPARE_CRYPTO_COIN_DATA2";
export const SET_COMPARE_CRYPTO_COIN_DATA1 = "SET_COMPARE_CRYPTO_COIN_DATA1";
export const SET_COMPARE_CRYPTO_COIN_DATA2 = "SET_COMPARE_CRYPTO_COIN_DATA2";
export const SET_CONVT = "SET_CONVT";
export const SEARCH_COINS = "SEARCH_COINS";
export const GET_NAMES_OF_DISPLAYED_CRYPTO_COINS =
  "GET_NAMES_OF_DISPLAYED_CRYPTO_COINS";
export const GET_CRYPTO_COINS_SPARKLINES = "GET_CRYPTO_COINS_SPARKLINES";

export const GET_FAVOURITE_CRYPTO_COINS_SPARKLINES =
  "GET_FAVOURITE_CRYPTO_COINS_SPARKLINES";
export const GET_SINGLE_CRYPTO_COINS_SPARKLINES =
  "GET_SINGLE_CRYPTO_COINS_SPARKLINES";
export const CLEAR_SPARKLINES = "CLEAR_SPARKLINES";
export const SET_CRYPTOSTR = "SET_CRYPTOSTR";
export const GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE =
  "GET_COMPARE_CRYPTO_COIN_DATA1_SPARKLINE";
export const GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE =
  "GET_COMPARE_CRYPTO_COIN_DATA2_SPARKLINE";
//auth
export const REGISTER_USER = "REGISTER_USER";

export const REGISTER_USER_WITH_GOOGLE = "REGISTER_USER_WITH_GOOGLE";
export const REGISTER_USER_WITH_FACEBOOK = "REGISTER_USER_WITH_FACEBOOK";

export const REGISTER_USER_WITH_GOOGLE_ERROR =
  "REGISTER_USER_WITH_GOOGLE_ERROR";
export const REGISTER_USER_WITH_FACEBOOK_ERROR =
  "REGISTER_USER_WITH_FACEBOOK_ERROR";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const LOGIN_USER = "LOGIN_USER";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const VERIFY_OTP = "VERIFY_OTP";
export const LOGOUT_USER = "LOGOUT_USER";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";
export const GET_USER = "GET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const EDIT_PROFILE = "EDIT_PROFILE";
export const FETCH_BDETAILS = "FETCH_BDETAILS";
export const ADD_BDETAILS = "ADD_BDETAILS";
export const WITHDRAW_MONEY = "WITHDRAW_MONEY";
export const HANDLE_PAYMENT_ERROR = "HANDLE_PAYMENT_ERROR";
export const FETCH_PENDING_DETAILS = "FETCH_PENDING_DETAILS";
export const HIDE_SWAL = "HIDE_SWAL";
export const DELETE_BDETAILS = "DELETE_BDETAILS";
export const GET_NEWS_BY_TOPIC = "GET_NEWS_BY_TOPIC";
export const GET_TOPICS = "GET_TOPICS";
//
export const POST_FAVOURITE_COIN = "POST_FAVOURITE_COIN";
export const GET_USER_WITH_FAVOURITE_COINS = "GET_USER_WITH_FAVOURITE_COINS";
export const GET_FAVOURITE_CRYPTO_COINS = "GET_FAVOURITE_CRYPTO_COINS";
//
//alert
export const SET_ALERT = "SET_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";

//
// VTRADING
export const TOGGLE_VTRADING_MODAL = "TOGGLE_VTRADING_MODAL";
export const SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT =
  "SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT";
export const SET_ACTIVE_CRYPTO_IN_VT = "SET_ACTIVE_CRYPTO_IN_VT";
export const SET_ACTIVE_PID_IN_VT = "SET_ACTIVE_PID_IN_VT";
export const PLACE_ORDER_IN_VT = "PLACE_ORDER_IN_VT";
export const PLACE_ORDER_IN_VT_ERROR = "PLACE_ORDER_IN_VT_ERROR";
export const GET_PARTICULAR_PORTFOLIO_IN_VT = "GET_PARTICULAR_PORTFOLIO_IN_VT";
export const SET_SELL_TYPE_IN_VT = "SET_SELL_TYPE_IN_VT";
export const GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT =
  "GET_COINS_IN_PARTICULAR_IN_VT";
export const FILTER_PORTID_IN_GET_USER_POSITION_IN_VT =
  "FILTER_PORTID_IN_GET_USER_POSITION_IN_VT";
export const SET_VIRTUAL_TRADING_BUTTON = "SET_VIRTUAL_TRADING_BUTTON";
export const SET_ACTIVE_PRICE = "SET_ACTIVE_PRICE";
export const TOGGLE_VTRADING_ALERT_MODAL = "TOGGLE_VTRADING_ALERT_MODAL";
export const SET_SELL_PRICE_FOR_STOP_LIMIT = "SET_SELL_PRICE_FOR_STOP_LIMIT";
export const PLACE_SELL_ORDER = "PLACE_SELL_ORDER";
export const CANCEL_ORDER_IN_VT = "CANCEL_ORDER_IN_VT";
export const MODIFY_ORDER_IN_VT = "MODIFY_ORDER_IN_VT";
export const SET_NET_PL = "SET_NET_PL";
export const SET_TOTAL_INV_AMOUNT = "SET_TOTAL_INV_AMOUNT";
export const SET_TOTAL_LOCK_AMOUNT = "SET_TOTAL_LOCK_AMOUNT";
export const SET_TOTAL_CURRENT_AMOUNT = "SET_TOTAL_CURRENT_AMOUNT";
export const CLEAR_VTRADING_ERROR = "CLEAR_VTRADING_ERROR";
export const CLEAR_VTRADING_MESSAGE = "CLEAR_VTRADING_MESSAGE";
export const SET_ALREADY_INVESTED = "SET_ALREADY_INVESTED";
export const START_VTRADING_LOADING = "START_VTRADING_LOADING";
export const STOP_VTRADING_LOADING = "STOP_VTRADING_LOADING";
export const CLEAR_COINS_DATA = "CLEAR_COINS_DATA";
export const MODIFY_NAME_IN_VT = "MODIFY_NAME_IN_VT";
export const CHECK_PAID_PORTFOLIO = "CHECK_PAID_PORTFOLIO";
export const BUY_NEW_PORTFOLIO = "BUY_NEW_PORTFOLIO";

//Tradathon
export const TRADATHON_CREATE_ROOM = "TRADATHON_CREATE_ROOM";
export const TRADATHON_CREATE_ROOM_ERROR = "TRADATHON_CREATE_ROOM_ERROR";
export const TRADATHON_ADD_COINS_ERROR = "TRADATHON_ADD_COINS_ERROR";
export const TRADATHON_ADD_COINS = "TRADATHON_ADD_COINS";
export const GET_LIVE_CONTESTS = "GET_LIVE_CONTESTS";
export const SET_ACTIVE_ROOM = "SET_ACTIVE_ROOM";
export const TRADATHON_GET_COINS = "TRADATHON_GET_COINS";
export const SET_TRADATHON_BUTTON = "SET_TRADATHON_BUTTON";
// export const SET_ACTIVE_PRICE = "SET_ACTIVE_PRICE";
export const TOGGLE_TRADATHON_ALERT_MODAL = "TOGGLE_TRADATHON_ALERT_MODAL";
export const SET_COIN_CST_AMOUNT = "SET_COIN_CST_AMOUNT";
export const TRADATHON_EDIT_COINS = "TRADATHON_EDIT_COINS";
export const TRADATHON_DELETE_COINS = "TRADATHON_DELETE_COINS";

export const TRADATHON_SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT =
  "SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT";
export const TRADATHON_SET_ACTIVE_CRYPTO_IN_VT = "SET_ACTIVE_CRYPTO_IN_VT";
export const TRADATHON_SET_ACTIVE_PID_IN_VT = "SET_ACTIVE_PID_IN_VT";
export const TRADATHON_PLACE_ORDER_IN_VT = "PLACE_ORDER_IN_VT";
export const TRADATHON_PLACE_ORDER_IN_VT_ERROR = "PLACE_ORDER_IN_VT_ERROR";
export const TRADATHON_GET_PARTICULAR_PORTFOLIO_IN_VT =
  "GET_PARTICULAR_PORTFOLIO_IN_VT";
export const TRADATHON_SET_SELL_TYPE_IN_VT = "SET_SELL_TYPE_IN_VT";
export const TRADATHON_GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT =
  "GET_COINS_IN_PARTICULAR_IN_VT";
export const TRADATHON_FILTER_PORTID_IN_GET_USER_POSITION_IN_VT =
  "FILTER_PORTID_IN_GET_USER_POSITION_IN_VT";
export const TRADATHON_SET_VIRTUAL_TRADING_BUTTON =
  "SET_VIRTUAL_TRADING_BUTTON";
export const TRADATHON_SET_ACTIVE_PRICE = "SET_ACTIVE_PRICE";
export const TRADATHON_TOGGLE_VTRADING_ALERT_MODAL =
  "TOGGLE_VTRADING_ALERT_MODAL";
export const TRADATHON_SET_SELL_PRICE_FOR_STOP_LIMIT =
  "SET_SELL_PRICE_FOR_STOP_LIMIT";
export const TRADATHON_PLACE_SELL_ORDER = "PLACE_SELL_ORDER";
export const TRADATHON_CANCEL_ORDER_IN_VT = "CANCEL_ORDER_IN_VT";
export const TRADATHON_MODIFY_ORDER_IN_VT = "MODIFY_ORDER_IN_VT";
export const TRADATHON_SET_NET_PL = "SET_NET_PL";
export const TRADATHON_SET_TOTAL_INV_AMOUNT = "SET_TOTAL_INV_AMOUNT";
export const TRADATHON_SET_TOTAL_LOCK_AMOUNT = "SET_TOTAL_LOCK_AMOUNT";
export const TRADATHON_SET_TOTAL_CURRENT_AMOUNT = "SET_TOTAL_CURRENT_AMOUNT";
export const TRADATHON_CLEAR_VTRADING_ERROR = "CLEAR_VTRADING_ERROR";
export const TRADATHON_CLEAR_VTRADING_MESSAGE = "CLEAR_VTRADING_MESSAGE";
export const TRADATHON_SET_ALREADY_INVESTED = "SET_ALREADY_INVESTED";
export const START_TRADATHON_LOADING = "START_TRADATHON_LOADING";
export const STOP_TRADATHON_LOADING = "STOP_TRADATHON_LOADING";
export const START_TRADATHON_ROOM_LOADING = "START_TRADATHON_ROOM_LOADING";
export const STOP_TRADATHON_ROOM_LOADING = "STOP_TRADATHON_ROOM_LOADING";
export const TRADATHON_CLEAR_COINS_DATA = "CLEAR_COINS_DATA";
export const TRADATHON_GET_LIVE_CONTEST_COINS =
  "TRADATHON_GET_LIVE_CONTEST_COINS";
export const GET_LEADERBOARD_OF_CONTEST = "GET_LEADERBOARD_OF_CONTEST";
export const SET_ACTIVE_ROOM_ID = "SET_ACTIVE_ROOM_ID";
export const PAY_FOR_TRADATHON = "PAY_FOR_TRADATHON";
export const CLEAR_ROOM_DATA = "CLEAR_ROOM_DATA";
export const CLEAR_TRADATHON_MESSAGE = "CLEAR_TRADATHON_MESSAGE";
export const CLEAR_TRADATHON_ERROR = "CLEAR_TRADATHON_ERROR";
export const SET_QUANTITY = "SET_QUANTITY";
export const TOGGLE_USER_ALERT_MODAL = "TOGGLE_USER_ALERT_MODAL";
export const FETCH_WALLET_AMOUNT = "FETCH_WALLET_AMOUNT";
export const GET_ROOM_MEMBER_DETAILS = "GET_ROOM_MEMBER_DETAILS";
export const CLEAR_VTRADING_DATA = "CLEAR_VTRADING_DATA";
export const GET_WINNINGS = "GET_WINNINGS";
export const CLEAR_LEADERBOARD = "CLEAR_LEADERBOARD";
export const TRADATHON_CLEAR_CONTESTS = "TRADATHON_CLEAR_CONTESTS";
export const TRADATHON_CLEAR_WINNINGS = "TRADATHON_CLEAR_WINNINGS";
export const SET_FCM_TOKEN = "SET_FCM_TOKEN";
export const GET_ROOM = "GET_ROOM";
export const CHECK_USER_JOINED= "CHECK_USER_JOINED";
export const SET_USER_JOINED= "SET_USER_JOINED";
export const GET_WINNINGS_DISTRIBUTION = "GET_WINNINGS_DISTRIBUTION";
export const START_JOINING= "START_JOINING";
export const STOP_JOINING= "STOP_JOINING";
// export const SET_SELL_PRICE_FOR_STOP_LIMIT= "SET_SELL_PRICE_FOR_STOP_LIMIT"
// export const PLACE_SELL_ORDER="PLACE_SELL_ORDER";
// export const CANCEL_ORDER_IN_VT= "CANCEL_ORDER_IN_VT";
// export const MODIFY_ORDER_IN_VT= "MODIFY_ORDER_IN_VT";
// export const SET_NET_PL= "SET_NET_PL";
// export const SET_TOTAL_INV_AMOUNT= "SET_TOTAL_INV_AMOUNT";
// export const SET_TOTAL_LOCK_AMOUNT= "SET_TOTAL_LOCK_AMOUNT"
// export const SET_TOTAL_CURRENT_AMOUNT= "SET_TOTAL_CURRENT_AMOUNT"
// export const CLEAR_VTRADING_ERROR= "CLEAR_VTRADING_ERROR"
// export const CLEAR_VTRADING_MESSAGE= "CLEAR_VTRADING_MESSAGE"
// export const SET_ALREADY_INVESTED= "SET_ALREADY_INVESTED"
// export const START_VTRADING_LOADING= "START_VTRADING_LOADING"
// export const STOP_VTRADING_LOADING= "STOP_VTRADING_LOADING"
// export const CLEAR_COINS_DATA= "CLEAR_COINS_DATA"
//NEWS
export const GET_SPECIFIC_NEWS = "GET_SPECIFIC_NEWS";
export const GET_GENERAL_NEWS = "GET_GENERAL_NEWS";
export const START_NEWS_LOADING = "START_NEWS_LOADING";
export const STOP_NEWS_LOADING = "STOP_NEWS_LOADING";
export const GET_EVENT_NEWS = "GET_EVENT_NEWS";
export const GET_NEWS = "GET_NEWS";
export const GET_NEWS_ERROR = "GET_NEWS_ERROR";
export const SET_NEWS_PAGE = "SET_NEWS_PAGE";
export const FILTER_NEWS_BY_SENTIMENT = "FILTER_NEWS_BY_SENTIMENT";
export const SET_FILTER_TYPE = "SET_FILTER_TYPE";
export const CLEAR_NEWS = "CLEAR_NEWS";
export const CHANGE_BALANCE = "CHANGE_BALANCE";
export const TOGGLE_PUBLIC_CONTEST_MODAL = "TOGGLE_PUBLIC_CONTEST_MODAL";
export const STOP_TOPICS_LOADING = "STOP_TOPICS_LOADING";
export const START_TOPICS_LOADING = "START_TOPICS_LOADING";
